/**
 * Recent objects slice – API call via createAsyncThunk + documentsAPI.
 */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getRecentObjects } from "../../api/documentsAPI";
import { serializeError } from "../../utils/serializeError";
import { trackRequest } from "../../utils/requestTracker";
import UserAuth from "../../../auth/userAuth";
import { logger } from "../../../utils/logger";

export const fetchRecentObjects = createAsyncThunk(
  "checkin/recentObjects/fetch",
  async (_, { rejectWithValue }) => {
    logger.info("fetchRecentObjects start", null, "REDUX");
    try {
      const tokenResponse = await new UserAuth().getUserToken(true);
      const accessToken = tokenResponse?.accessToken;
      if (!accessToken) {
        logger.error("fetchRecentObjects no access token", tokenResponse, "REDUX");
        return rejectWithValue(serializeError({ message: "No access token" }));
      }
      const result = await trackRequest("fetchRecentObjects", () =>
        getRecentObjects(accessToken)
      );
      logger.info("fetchRecentObjects success", null, "REDUX");
      return result;
    } catch (error) {
      logger.error("fetchRecentObjects failed", error, "REDUX");
      return rejectWithValue(serializeError(error));
    }
  }
);

const recentObjectsSlice = createSlice({
  name: "checkin/recentObjects",
  initialState: {
    loading: false,
    error: null,
    data: null,
  },
  reducers: {
    clearRecentObjectsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecentObjects.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRecentObjects.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload?.data ?? null;
      })
      .addCase(fetchRecentObjects.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? serializeError(action.error);
      });
  },
});

export const { clearRecentObjectsError } = recentObjectsSlice.actions;
export default recentObjectsSlice.reducer;
